import styled from 'styled-components';

export const StyledScrollbar = styled.div`
  .custom-scrollbars__container {
    width: 100%;
    overflow: hidden;
    position: relative;
  }

  .custom-scrollbars__content {
    width: 100%;
    -ms-overflow-style: none;
    overflow-x: auto;
    padding: 0 1rem;
    scrollbar-width: none;
  }

  .custom-scrollbars__content::-webkit-scrollbar {
    display: none;
  }

  .custom-scrollbars__scrollbar {
    display: grid;
    gap: 1rem;
    grid-auto-flow: row;
    grid-template: 1fr;
    padding: 1rem;
    place-items: center;
  }

  .custom-scrollbars__track-and-thumb {
    display: block;
    height: 16px;
    position: relative;
    width: 100%;
  }

  .custom-scrollbars__track {
    background-color: #eee;
    border-radius: 12px;
    height: 16px;
    width: 100%;
    cursor: pointer;
    position: absolute;
    bottom: 0;
    left: 0;
  }

  .custom-scrollbars__thumb {
    border-radius: 12px;
    background-color: ${({ theme }) => theme.colors.link};
    position: absolute;
    height: 16px;

    svg {
      stroke: ${({ theme }) => theme.colors.white};
      position: absolute;
      left: calc(50% - 12px);
      top: -4px;
      cursor: inherit;
    }
  }
`;
